<template>
  <div>
    <div v-if="!enterDetail">
      <div id="mission" v-show="!enterChat">
        <div class="divContent" >
          <div class="divVideo">
           <!-- <img :src='currentVideoFaceSrc' class="video-img" @click="handlePlayVideo"/> -->
            <div class="dialog">
              <video id="my-video" @click="handlePlayVideo" width="100%" height="100%" :poster='currentVideoFaceSrc' ref="dialogVideo1">
                <source :src='currentVideoSrc' type="video/mp4">
              </video>
            </div>
          </div>
          <span class="icon-box"><i class="iconfont icon-bofang" title="播放" @click="handlePlayVideo"></i></span>
        </div>
        <div class="divBottom">
           <button class="back-button" @click="emitBackActivities" >返回活动广场</button>
           <button @click="handlePlayMission" class="next-button" >我已了解，开始闯关</button>
        </div>
      </div>
      <div id="chat" v-if="enterChat" >
        <Player @backMission="handleBackMission"/>
      </div>
    </div>
    <div v-else>
      <MissionDetail :id="id"/>
    </div>
    <div class="v-modal-new" v-show="dialogVideoVisible" @click="handleCloseVideo">
      <div class="dialogWrapper" >
        <div class="dialog" >
          <video controls width="100%" height="100%" :poster='currentVideoFaceSrc' ref="dialogVideo">
            <source :src='currentVideoSrc' type="video/mp4">
          </video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Player from '@/page/player/PagePlayerMobile'
import MissionDetail from '@/page/missionDetail'
import setWechatTitle from '@/utils/setWechatTitle.js'
import moment from 'moment'
import Video from 'video.js'
export default {
  name: 'Mission',
  props: {
    id: Number,
  },
  components: {
    Player,
    MissionDetail,
  },

  data () {
    console.log('开始 mission data() id：'+this.id)
    return {
      enterChat: false,
      enterDetail: false,
			missionNames : ['疯狂动物城','生涯罗盘','大学生ToDoList',
			'职业倾向测评','职业世界探索','职业倾向匹配',
			'优秀大学生图鉴','职业能力知多少','目标职位能力大赏',
			'决策风格测评','毕业去向探索','我的决策产生记',
			'生涯扫雷'],
      bulletlist: [], //弹幕数据，最多5条
      dialogVideoVisible: false,
      invalid:true,
      guanzhu:true
		}
  },
  computed: {
    ...mapState({
      currentMessageList: state => state.conversation.currentMessageList,
      // currentGroupMemberNum: state => state.conversation.currentGroupMemberNum,
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
		partnerCode() {
			return this.shengyaUser.admin.manageAccCode.replace('admin','')
		},
    groupID() {
      return this.partnerCode+'-cos-mission-' + this.id
    },
    conversationID() {
      return 'GROUP'+this.partnerCode+'-cos-mission-' + this.id
    },
    currentInOutList() {
      let inOutList = []
      this.currentMessageList.forEach(message => {
        var newMessateText =message.payload.text
        if(newMessateText){
          inOutList.push(newMessateText)
        }
      })
      return inOutList
    },
		currentMissionName() {
			const missionIndex = this.id -1
			return this.missionNames[missionIndex]
		},
		currentBannerImgSrc() {
      return 'http://sys.rennengda.com/public/images/mission/mission-banner-' + this.id+ '.jpg'
		},
    currentVideoFaceSrc() {
      return 'http://sys.rennengda.com/public/video/face/mission-video-' + this.id+ '.JPG'
    },
    currentVideoSrc() {
      return 'http://sys.rennengda.com/public/video/mission-' + this.id+ '.mp4'
    },
		timUserId() {
			return 'user'+ this.shengyaUser.userId
		},
		nickname() {
			return this.shengyaUser.studentCollege + this.shengyaUser.studentName
		},
    randomGuanzhuID() {
      let object =JSON.parse(this.shengyaUser.admin.jsonSetting)
      let n=12
      if(object&&object.gzCount){
        n=object.gzCount
      }
      let f=this.shengyaUser.userId % n +1
      return f
    },
    randomGuanzhuCode() {
      return this.partnerCode+'-guanzhu-' + this.randomGuanzhuID
    },
		currentGuanzhuImgSrc() {
			// return 'http://sys.rennengda.com/public/images/guanzhu/guanzhu-' + this.randomGuanzhuID+ '.jpg'
      return 'http://sys.rennengda.com/public/images/guanzhu/guanzhu-1.jpg'
		},
    chatConversationID() {
      return 'C2C'+this.randomGuanzhuCode
    },
    // checkStatus(){
    //   let invalid=true
    //   let endDate = this.shengyaUser.admin.endDate
    //   let diffEndDate = moment(endDate).diff(moment().format(), 'days')
    //   let startDate = this.shengyaUser.admin.startDate
    //   let diffStartDate = moment(startDate).diff(moment().format(), 'days')      
    //   if(diffStartDate<=0&&diffEndDate>=0){
    //     invalid = false
    //   }
    //   this.invalid = invalid
    //   return invalid
    // },
  },
  //弹幕
  watch: {
    // currentMessageList() {
    //   let _this = this
    //   this.currentMessageList.forEach(message => {
    //     if (message.payload.text && message.conversationID==this.conversationID &&
    //         message.payload.text.indexOf('finish-')>0 ){
    //         var newMessateText = message.payload.text.replace('finish-','')
    //         var found = false
    //         _this.bulletlist.some(bullet =>{
    //           if (bullet == newMessateText) {
    //             found = true
    //             return true
    //           }
    //         })
    //         if (!found ) {
    //           _this.bulletlist.push(newMessateText)
    //           if (_this.bulletlist>5) { //最多5条
    //             _this.bulletlist.shift()
    //           }
    //         }
    //       }
    //   })
    // }
  },
  created(){
    setWechatTitle('生涯驿站-'+this.missionNames[this.id-1]);
  },
  mounted() {
    console.log('开始 mission mounted groupID：'+ this.groupID)
    this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
    this.$bus.$on('back-mission', this.handleBackMission)
    this.$bus.$on('enter-chat', this.handleEnterChat)
    const myVideo = this.$refs.dialogVideo
    this.$nextTick(() => {
        myVideo.addEventListener('play', this._bindHandlerFull)
        myVideo.addEventListener('ended', this._unbindHandlerFull)
      })
  },
  updated() {
    this.keepMessageListOnButtom()
  },
  beforeDestroy () {
    // console.log('开始 mission beforeDestroy() 关闭监听')
    this.$bus.$off('back-mission')
    this.$bus.$off('enter-chat')
  },
  methods: {
    // 检查关主状态
    guanzhuStatus(num){
       let invalid=true
       let object =JSON.parse(this.shengyaUser.admin.jsonSetting)
       if(num==1){
         if(object&&object.guanzhu){
           invalid=false
         }
         this.guanzhu = invalid
       }
       return invalid
    },
    handlePlayVideo() {
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if(!isiOS){
        this.dialogVideoVisible = true
        // 弹出框时 视频开始播放
        this.$refs.dialogVideo.play()
      }else{
        this.$refs.dialogVideo1.play()
      }
    },
		handleCloseVideo() {
      this.dialogVideoVisible = false
      // 关闭弹出框时 视频关闭播放
      this.$refs.dialogVideo.pause();
    },
    onScroll({ target: { scrollTop } }) {
      let messageListNode = this.$refs['inOut-list']
      if (!messageListNode) {
        return
      }
      if (this.preScrollHeight - messageListNode.clientHeight - scrollTop < 20) {
        this.isShowScrollButtomTips = false
      }
    },
    // 如果滚到底部就保持在底部，否则提示是否要滚到底部
    keepMessageListOnButtom() {
      let messageListNode = this.$refs['inOut-list']
      if (!messageListNode) {
        return
      }
      // 距离底部20px内强制滚到底部,否则提示有新消息
      if (this.preScrollHeight - messageListNode.clientHeight - messageListNode.scrollTop < 20) {
        this.$nextTick(() => {
          messageListNode.scrollTop = messageListNode.scrollHeight
        })
        this.isShowScrollButtomTips = false
      } else {
        this.isShowScrollButtomTips = true
      }
      this.preScrollHeight = messageListNode.scrollHeight
    },
    // 直接滚到底部
    scrollMessageListToButtom() {
      this.$nextTick(() => {
        let messageListNode = this.$refs['inOut-list']
        if (!messageListNode) {
          return
        }
        messageListNode.scrollTop = messageListNode.scrollHeight
        this.preScrollHeight = messageListNode.scrollHeight
        this.isShowScrollButtomTips = false
      })
    },
    //返回活动广场
    emitBackActivities() {
      // this.$store.dispatch('quitMissionGroup',this.id)
        this.$emit('back-activities')
    },
    //进入答疑室
    handleEnterChat() {
      if(!this.guanzhu){
        this.enterDetail = false
        this.enterChat = true
      }
    },
    //闯关
    handlePlayMission() {
      // let status = this.checkStatus
      // if(this.invalid){
        this.enterDetail = true
      // }else if(!status){
      //   this.$store.commit('showMessage', {
      //     message: '已过有效期，暂不能使用该功能',
      //     type: 'warning',
      //     duration:4000
      //   })
      // }
    },
    //返回关主首页
		handleBackMission() {
      this.enterDetail = false
			this.enterChat = false
      //先退出答疑室
      // this.$store.dispatch('quitChatGroup',this.chatID)
      //切换到闯关
      // this.$store.commit('updateJoinGroupState', false)
      // const missionConversationID = 'GROUP'+this.partnerCode+'-cos-mission-'+this.id
      // this.$store.dispatch('checkoutConversation',missionConversationID)
    },
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
/* //上面顶图 */
.banner
  position: relative
  overflow: hidden
  height: 0
  padding-bottom: 62.4%
  padding-left:  0.24rem
  padding-right:  0.24rem

.banner .banner-img
  width: 100%

/* //中间 */
.header
  overflow: hidden
  display: -webkit-box
  display: -ms-flexbox
  display: flex
  /* height: 1.0rem  */
  padding: 0.12rem 0.24rem

  .header-img
    float:left
    padding: 0 0.1rem
    img
      width: 0.84rem
      height: 0.84rem
  .header-button
    flex: 1
    line-height: 0.44rem
    background: #DC6E5A
    margin-left: 0.2rem
    padding: 0.05rem 0.2rem
    border-radius: 0.06rem
    color: #fff
  .invalid
    background :#BBBBBB
  .header-info
    float:right
    line-height: 0.44rem
    margin-left: 1rem
    padding: 0.05rem 0.2rem
    color: #777
/* //下面 */
.divContent
    overflow: hidden
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    position:relative
    .icon-box
      position:absolute
      right:50%
      /*margin-right: -2rem*/
      top: 50%
      /*margin-top: -0.5rem*/
      background-color: #ffffff
      border-radius: 50%
      width: 0.4rem
      height: 0.4rem
      z-index:100
      .iconfont
        font-size:0.8rem
        position: relative
        margin-left: -0.2rem
        margin-top: 0.5rem

.divMessage
    overflow: auto
    margin:0 0.24rem
    width: 43.6%
    min-width: 43.6%
    max-height: 5.72rem

.divMessage .liMessage
    overflow: hidden
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    margin: 0.14rem 0

.divMessage .liMessage .pMessage,.divBarrage .liBarrage .pBarrage
    border-radius: 0.12rem
    background: #787878
    padding: 0.08rem 0.24rem
    font-size: 0.24rem
    flex-wrap: wrap
    line-height: 0.32rem

.message-title
    color: #79CDE1

.message-mission-start
    color: #F0F0F0
    margin-left: 0.2rem

.message-mission-finish
    color: #DC6E5A
    margin-left: 0.2rem

.divVideo
    margin: 0 auto
    overflow: hidden
    margin-top: 0.24rem;
    padding-left: 0.24rem
    padding-right: 0.48rem
    position:relative
    .video-img
      width: 100%
.video-info
    margin-top: 0.1rem
    line-height: 0.32rem
    font-size: 0.24rem
.divBottom
    /* height: 1.0rem  */
    padding: 0.24rem

.divBottom .back-button
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #787878
    border-radius: 0.12rem
    color: #fff

.divBottom .next-button
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #DC6E5A
    border-radius: 0.12rem
    color: #fff
.divBottom  .disabled-btn
    background :#BBBBBB
.divBottom .invalid
    background :#BBBBBB
/*滚动文字的样式*/
.text-container
  position: absolute
  bottom: 0.5rem
  height: 30px
  line-height: 30px
  margin: 10px auto
  overflow: hidden

.text
  margin: 0
  float:left
  // background: rgba(120,120,120,0.7)
  color:#FF7F00
  // color:#FFF
  padding:0 10px
  border-radius:10px
  margin-right:20px
  text-shadow: 1px 1px 1px #000
.inner-container
    width:400%
    animation: myMove 20s linear infinite
    animation-fill-mode: forwards
    @keyframes myMove
      0%
        transform translateX(0)
      100%
        transform translateX(-1300px)

.dialogWrapper
  z-index: 2002
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  .dialog
    margin: 10%;
    // width: 80%;
    position: relative;
.v-modal-new
  z-index: 2001
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  // opacity: .7;
  background: #000;
</style>
